export const NotificationTypes = Object.freeze({
  INFO: "Info",
  SUCCESS: "Success",
  WARNING: "Warning",
  ERROR: "Error",
  APPROVAL_REQUIRED: "ApprovalRequired",
  REMINDER: "Reminder",
});

export const NotificationPriorities = Object.freeze({
  LOW: "Low",
  NORMAL: "Normal",
  HIGH: "High",
  CRITICAL: "Critical",
});

export const NotificationReadStatuses = Object.freeze({
  READ: "Read",
  UNREAD: "Unread",
});

export const NotificationEventLogStatuses = Object.freeze({
  SUCCESS: "Success",
  FAILED: "Failed",
  SKIPPED: "Skipped",
});
